import { createSelector } from "reselect";
const getConfigInfo = (state) => state && state.config;
export const getInstrumentDetailUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/instruments/`
            : '',
);
export const getSystemDetailUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/instruments/get-instrument-system`
            : '',
);

export const getContractLineItemsCountUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/contracts/get-contract-line-items-count`
            : '',
);

export const getRequestGroupUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/work-request/group`
            : '',
);

